import React from 'react';
import classNames from 'classnames';

interface BgPageWrapperProps {
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
}

const BgPageWrapper: React.FC<BgPageWrapperProps> = (props) => {
    const { className, style, children } = props;
    return (
        <div
            className={classNames('fx-bg-page-wrapper', className)}
            style={{
                ...style
            }}
        >
            {children}
        </div>
    );
};

export default BgPageWrapper;
